import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Siegel-5.png")